import { AmendmentBox } from "@logora/parliament.amendment.amendment_box";
import React from "react";
import { amendementDataset } from "../../datasets";
import { List } from "../../search/List";
import styles from "./AmendementList.module.scss";

export const AmendementList = ({ document, subdivisionRefHash = null }) => {
	const excludedColumns = ["numeroLong", "uid", "chambre", "dateDepot"];

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.title}>Amendements</div>
			</div>
			<div className={styles.contentContainer}>
				{document?.uid && (
					<List
						dataset={{
							...amendementDataset,
							columns: amendementDataset.columns.filter(
								(column) => !excludedColumns.includes(column.accessorKey),
							),
						}}
						globalFilters={{
							documentRefUid: document.uid,
							...(subdivisionRefHash && {
								subdivisionRefHash: subdivisionRefHash,
							}),
						}}
						display={true}
						key={document.uid}
						role="tabpanel"
						tabIndex={0}
						showSearch
						disableSyncWithLocation
						Children={AmendmentBox}
						searchPlaceholder={"Rechercher un amendement..."}
						emptyText={"Pas d'amendement déposé"}
					/>
				)}
			</div>
		</div>
	);
};
